import { buildVisitRenderSnippet } from "./visit-render-snippet";
import { useVisitId } from "./VisitContext";

export const VISIT_SCRIPT_ID = "acd-pv";

/** Lo que el server escribió en el snippet, leído una sola vez en el navegador. */
let clientSnippet: string | null | undefined;

function readClientSnippet(): string | null {
  if (clientSnippet === undefined) {
    clientSnippet = document.getElementById(VISIT_SCRIPT_ID)?.innerHTML ?? null;
  }
  return clientSnippet;
}

/**
 * Snippet de render del registro de visitas (ver `visit-render-snippet.ts`).
 *
 * - Server: el id viene de `VisitIdProvider` (`entry.server.tsx`). Sin id (p. ej. /admin) no se
 *   renderiza nada.
 * - Navegador: no hay id en React. Se reusa el `innerHTML` que ya está en el DOM, así el árbol es
 *   idéntico al del SSR y no hay mismatch; un `<script>` que React reinserta no se vuelve a
 *   ejecutar. Si el nodo no existe (el server no puso snippet), `null` en los dos lados.
 */
export function VisitRenderScript() {
  const visitId = useVisitId();
  const html =
    typeof document === "undefined" ? buildVisitRenderSnippet(visitId) : readClientSnippet();
  if (!html) return null;
  return (
    <script
      id={VISIT_SCRIPT_ID}
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

/** Sólo para tests. */
export function __resetVisitRenderScriptForTests() {
  clientSnippet = undefined;
}
